/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface InvitationTokenInfoResponse {
  email: string;
  org_name: string;
  org_logo_url?: string | null;
  role?: string;
  inviter_name?: string | null;
  invitation_state?: string;
}
